export const JSON_MIME = "application/json"
export const FETCH_ERROR = Symbol()
export const CATCHER_FALLBACK = Symbol()
